import React, {
  useState,
  useRef,
  useMemo,
  useEffect,
} from "react";
import axiosInstance from "../../../utils/axiosInstance";
import { useSelector } from "react-redux";
import Bootstrap4DatePickerComponent from "../components/Bootstrap4DatePickerComponent";
import $ from "jquery";
import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";

const moment = require("moment");

const BetHistoryContent = ({ targetUserId = null, displayUsername = "" }) => {
  const today = new Date();
  const year = today.getFullYear();
  const monthIndex = today.getMonth();
  const dayOfMonth = today.getDate();

  const todayStart = new Date(year, monthIndex, dayOfMonth, 0, 0, 0, 0);
  const todayEnd = new Date(year, monthIndex, dayOfMonth, 23, 59, 59, 999);

  const [selectedFromDate, setSelectedFromDate] = useState(todayStart);
  const [selectedToDate, setSelectedToDate] = useState(todayEnd);
  const [sportsType, setSportsType] = useState(0);
  const [betStatus, setBetStatus] = useState(0);
  const [data, setData] = useState([]);
  const [uniqueGridKey, setUniqueGridKey] = useState(Date.now());
  const [pageSize, setPageSize] = useState(50);

  const gridTableRef = useRef(null);
  const defaultExpand = true;

  const userInfo = useSelector((state) => state.userStore);

  let username = displayUsername;
  if (
    !username &&
    userInfo !== null &&
    userInfo !== undefined &&
    userInfo.data !== null &&
    userInfo.data !== undefined
  ) {
    username = userInfo.data.uname;
  }

  const handleSportsType = (e) => {
    setSportsType(e.target.value);
  };

  const handleBetStatus = (e) => {
    setBetStatus(e.target.value);
  };

  const formatDateTime = (value) => {
    if (!value) return "";
    return moment(value).format("YYYY-MM-DD hh:mm:ss");
  };

  const cols = useMemo(
    () => [
      {
        title: "#",
        data: "seq",
        orderable: true,
        className: "dt-center",
        responsivePriority: 1,
        render: (val, type) => {
          if (type === "display" || type === "filter") {
            return `
              <div class="seq-cell">
                <span class="seq-number">${val}</span>
                <button type="button" class="toggle-row toggle-closed">+</button>
              </div>
            `;
          }
          return val;
        }
      },
      {
        title: "Event",
        data: "event_name",
        className: "min-desktop dt-left",
        responsivePriority: 10001,
        render: (val) => `<span>${val ?? ""}</span>`
      },
      {
        title: "Runner",
        data: "section",
        className: "dt-left",
        responsivePriority: 2,
        render: (val) => `<span>${val ?? ""}</span>`
      },
      {
        title: "Price",
        data: "rate",
        className: "min-desktop dt-right",
        responsivePriority: 10002,
        render: (val) => `<span>${formatTruncate(Math.round(val)) ?? ""}</span>`
      },
      {
        title: "Amount",
        data: "amnt",
        className: "min-desktop dt-right",
        responsivePriority: 10003,
        render: (val) => `<span>${formatTruncate(Math.round(val)) ?? ""}</span>`
      },
      {
        title: "Position",
        data: "pro",
        className: "min-desktop dt-right",
        responsivePriority: 10004,
        //render: (val) => `<span>${formatTruncate(Math.round(val)) ?? ""}</span>`
        render: (val) => `<span>0</span>`
      },
      {
        title: "Placed",
        data: "stmp",
        className: "min-desktop dt-right",
        responsivePriority: 10005,
        render: (val, type) => {
          if (type === "display" || type === "filter") {
            return `<span>${formatDateTime(val)}</span>`;
          }
          return val ? new Date(val).getTime() : 0;
        }
      },
      {
        title: "Updated",
        data: "updated_stmp",
        className: "min-desktop dt-right",
        responsivePriority: 10006,
        render: (val, type, row) => {
          const displayVal = val ?? row.stmp;
          if (type === "display" || type === "filter") {
            return `<span>${formatDateTime(displayVal)}</span>`;
          }
          return displayVal ? new Date(displayVal).getTime() : 0;
        }
      },
      {
        title: "type",
        data: "type",
        visible: false,
        responsivePriority: 10007
      }
    ],
    []
  );

  const fetchBetHistory = async () => {
    const obj = {
      bet_status: betStatus,
      from_date: selectedFromDate,
      to_date: selectedToDate,
    };

    if (Number(sportsType) !== 0) {
      obj.sports_type = Number(sportsType);
    }

    const response = targetUserId
      ? await axiosInstance.post("/master/betlist", {
          ...obj,
          user_id: targetUserId,
        })
      : await axiosInstance.post("/bets/user-betlist/", {
          ...obj,
          sports_type: sportsType,
        });

    if (
      response.data !== null &&
      response.data.bets_list !== null &&
      response.data.bets_list !== undefined
    ) {
      setData(response.data.bets_list);
      setUniqueGridKey(Date.now());
    } else {
      setData([]);
      setUniqueGridKey(Date.now());
    }
  };

  const handleSubmit = async (event) => {
    if (event?.preventDefault) {
      event.preventDefault();
    }
    await fetchBetHistory();
  };

  useEffect(() => {
    fetchBetHistory();
  }, [targetUserId]);

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(Number(event.target.value));
  };

  useEffect(() => {
    if (!data.length) return;

    const $table = $(gridTableRef.current);
    if (!$table.length) return;

    if ($.fn.dataTable.isDataTable($table)) {
      const dt = $table.DataTable();
      $table.off("click", "button.toggle-row");
      dt.off("order.dt search.dt draw.dt");
      dt.off("responsive-resize draw");
      dt.destroy(true);
      $table.empty();
    }

    const normalizedCols = (cols || []).map((c) => ({
      ...c,
      title: c.title || c.sTitle || "",
      data: c.data || c.mData || c.name || "",
      orderable: typeof c.orderable === "boolean" ? c.orderable : true
    }));

    if (normalizedCols[0]) {
      normalizedCols[0].orderable = true;
    }

    const keys = normalizedCols.map((c) => c.data).filter(Boolean);
    const safeData = (data || []).map((row, i) => {
      const out = { seq: i + 1 };
      keys.forEach((k) => {
        if (k in row) out[k] = row[k];
      });
      return out;
    });

    let dt;
    try {
      dt = $table.DataTable({
        data: safeData,
        columns: normalizedCols,
        responsive: { details: false },
        pageLength: pageSize || 50,
        lengthChange: false,
        autoWidth: false,
        ordering: true,
        orderSequence: ["asc", "desc"],
        order: [[0, "asc"]],
        columnDefs: [
          {
            targets: 0,
            orderable: true,
            width: "6%",
            className: "dt-center",
            orderSequence: ["asc", "desc"]
          },
          {
            targets: 1,
            width: "24%",
            className: "min-desktop dt-left",
            orderSequence: ["asc", "desc"]
          },
          {
            targets: 2,
            width: "18%",
            className: "dt-left",
            orderSequence: ["asc", "desc"]
          },
          {
            targets: 3,
            width: "10%",
            className: "min-desktop dt-right",
            orderSequence: ["asc", "desc"]
          },
          {
            targets: 4,
            width: "10%",
            className: "min-desktop dt-right",
            orderSequence: ["asc", "desc"]
          },
          {
            targets: 5,
            width: "10%",
            className: "min-desktop dt-right",
            orderSequence: ["asc", "desc"]
          },
          {
            targets: 6,
            width: "11%",
            className: "min-desktop dt-right",
            orderSequence: ["asc", "desc"]
          },
          {
            targets: 7,
            width: "11%",
            className: "min-desktop dt-right",
            orderSequence: ["asc", "desc"]
          }
        ],
        dom: '<"top d-flex flex-wrap justify-content-between align-items-center" <"dataTables_length"l> <"dt-search"f> >rt<"bottom d-flex justify-content-between align-items-center"ip><"clear">',
        language: {
          paginate: { previous: "&laquo;", next: "&raquo;" }
        },
        orderClasses: false,
        rowCallback: (row, rowData) => {
          const isBack =
            rowData.type?.toLowerCase() === "b" ||
            rowData.type?.toLowerCase() === "y";
          const bg = isBack ? "#b8daff" : "#f6c6cc";
          $(row).find("td").css("background-color", bg);
        }
      });
    } catch (error) {
      console.error("Error initializing Bet History DataTable:", error);
      return;
    }

    const getHiddenColumnsForRow = (tr) => {
      const hiddenCols = [];
      $(tr)
        .find("td")
        .each((i, td) => {
          if ($(td).css("display") === "none" || $(td).is(":hidden")) {
            hiddenCols.push(i);
          }
        });
      return hiddenCols;
    };

    const buildHiddenDetails = (rowData, tr) => {
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length) {
        return "";
      }

      let html = "";
      hiddenCols.forEach((i) => {
        const col = dt.column(i);
        if (!col || !col.header()) return;

        const title = ($(col.header()).text() || "").trim();
        if (!title) return;

        const colDef = normalizedCols[i];
        const rawVal = rowData[colDef.data];
        const rendered = colDef.render
          ? colDef.render(rawVal, "display", rowData, { row: 0, col: i })
          : rawVal ?? "";

        const safeTitle = title
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");

        html += `
      <tr>
        <td class="ledger-detail-cell">
          <div class="ledger-detail-line">
            <span class="ledger-detail-label">${safeTitle}:</span>
            <div class="ledger-detail-value">${rendered}</div>
          </div>
        </td>
      </tr>`;
      });
      return html;
    };

    const updateToggleButtons = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      dt.rows().every(function () {
        const tr = $(this.node());
        const $btn = tr.find("button.toggle-row");
        const hiddenCols = getHiddenColumnsForRow(tr);
        const anyHidden =
          hiddenCols.length > 0 && hiddenCols.length < normalizedCols.length;

        if (anyHidden) {
          $btn.show();
          if (defaultExpand && !this.child.isShown()) {
            const details = buildHiddenDetails(this.data(), tr);
            if (details.trim()) {
              this.child(
                `<table class="table table-sm mb-0 ledger-child-table">${details}</table>`
              ).show();
              tr.addClass("shown");
              $btn
                .text("−")
                .removeClass("toggle-closed")
                .addClass("toggle-open");
            }
          } else if (this.child.isShown()) {
            const newDetails = buildHiddenDetails(this.data(), tr);
            this.child(
              `<table class="table table-sm mb-0 ledger-child-table">${newDetails}</table>`
            ).show();
          }
        } else {
          $btn.hide();
          if (this.child && this.child.isShown()) {
            this.child.hide();
            tr.removeClass("shown");
          }
        }
      });
    };

    $table.on("click", "button.toggle-row", function () {
      const tr = $(this).closest("tr");
      const row = dt.row(tr);
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length) {
        return;
      }
      if (row.child.isShown()) {
        row.child.hide();
        tr.removeClass("shown");
        $(this).text("+").removeClass("toggle-open").addClass("toggle-closed");
      } else {
        const details = buildHiddenDetails(row.data(), tr);
        if (!details.trim()) return;
        row
          .child(
            `<table class="table table-sm mb-0 ledger-child-table">${details}</table>`
          )
          .show();
        tr.addClass("shown");
        $(this).text("−").removeClass("toggle-closed").addClass("toggle-open");
      }
    });

    dt.on("order.dt search.dt draw.dt", () => {
      try {
        updateToggleButtons();
      } catch (e) {
        console.warn("Toggle update failed:", e);
      }
    });

    requestAnimationFrame(() => {
      updateToggleButtons();
    });

    const safeRecalc = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      clearTimeout(window.__bet_history_dt_timer);
      window.__bet_history_dt_timer = setTimeout(() => {
        try {
          dt.responsive.recalc();
          requestAnimationFrame(() => updateToggleButtons());
        } catch (err) {
          console.warn("Resize skip:", err);
        }
      }, 30);
    };

    dt.on("responsive-resize draw", safeRecalc);
    window.addEventListener("resize", safeRecalc);

    return () => {
      window.removeEventListener("resize", safeRecalc);
      clearTimeout(window.__bet_history_dt_timer);
      $table.off("click", "button.toggle-row");
      if ($.fn.dataTable.isDataTable($table)) {
        try {
          const dtInstance = $table.DataTable();
          if (dtInstance) {
            dtInstance.off("order.dt search.dt draw.dt");
            dtInstance.off("responsive-resize draw");
            dtInstance.destroy(true);
          }
        } catch (error) {
          console.warn("Error during Bet History DataTable cleanup:", error);
        }
      }
    };
  }, [cols, data, pageSize, defaultExpand]);

  return (
    <>
      <div className="right-side-wrapper-row">
        <div className="tab-panes-wrapper-row">
          <div className="container-fluid ">
            <div
              className="row"
              style={{ marginTop: "0%", marginBottom: "3%" }}
            >
              <div className="col-12 col-md-12">
                <div className="card">
                  <div className="content-wrap body">
                    <div className="table-wrap">
                      <div className="row">
                        <div
                          className="col-md-12"
                          style={{ marginBottom: "0px" }}
                        >
                          <div className="card">
                            <div className="card-header">
                              <i className="fa fa-align-justify"></i>
                              Bets History
                            </div>
                            <div className="card-body">
                              <form
                                id="BetHistoryFilterForm"
                                method="post"
                                className="form-inline"
                              >
                                <div className="row w-100 bet-history-filter-row">
                                  <div className="col-6 col-md-auto bet-history-filter-select">
                                    <select
                                      className="form-control"
                                      value={String(sportsType)}
                                      onChange={handleSportsType}
                                    >
                                      <option value="0">All</option>
                                      <option value="1">Cricket</option>
                                      <option value="2">Soccer</option>
                                      <option value="3">Tennis</option>
                                      <option value="4">Horse Race</option>
                                      <option value="5">Greyhound</option>
                                    </select>
                                  </div>
                                  <div className="col-6 col-md-auto bet-history-filter-select">
                                    <select
                                      className="form-control"
                                      value={String(betStatus)}
                                      onChange={handleBetStatus}
                                    >
                                      <option value="0">Active</option>
                                      <option value="1">Settled</option>
                                      <option value="2">Voided</option>
                                      <option value="3">Cancelled</option>
                                    </select>
                                  </div>
                                  <div className="col-12 col-md-4 bet-history-filter-date bet-history-filter-date-from">
                                    <Bootstrap4DatePickerComponent
                                      pickerId="BetHistoryFrom"
                                      inputId="BetHistoryFromInput"
                                      defaultDate={selectedFromDate}
                                      setSelectedDate={setSelectedFromDate}
                                    />
                                  </div>
                                  <strong className="bet-history-filter-dash">
                                    &nbsp;-&nbsp;
                                  </strong>
                                  <div className="col-12 col-md-4 bet-history-filter-date">
                                    <Bootstrap4DatePickerComponent
                                      pickerId="BetHistoryTo"
                                      inputId="BetHistoryToInput"
                                      defaultDate={selectedToDate}
                                      setSelectedDate={setSelectedToDate}
                                    />
                                  </div>
                                  <div className="form-group editsbmtbtn">
                                    <label className="mx-1"> </label>
                                    <button
                                      className="btn btn-primary"
                                      type="submit"
                                      onClick={handleSubmit}
                                      style={{
                                        backgroundColor: "#00b181",
                                        border: "none",
                                        padding: "0.375rem 0.85rem"
                                      }}
                                    >
                                      <strong>Submit</strong>
                                    </button>
                                  </div>
                                </div>
                                <div className="row col-12"></div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="table-wrap">
                      <div className="card">
                        <div className="card-header">
                          <i className="fa fa-align-justify"></i> Bets History{" "}
                          <b>({username}) </b>
                        </div>

                        <div className="card-body" style={{ padding: "0px" }}>
                          <div
                            id="betHistoryTable_wrapper"
                            className="dataTables_wrapper no-footer py-2 px-2"
                          >
                            <div className="row actionBtn">
                              <div className="col-12 col-sm-4">
                                <div
                                  className="dataTables_length"
                                  id="betHistoryTable_length"
                                >
                                  <label>
                                    <select
                                      name="betHistoryTable_length"
                                      aria-controls="betHistoryTable"
                                      className="form-control d-inline-block w-auto"
                                      value={pageSize}
                                      onChange={handlePageSizeChange}
                                    >
                                      <option value="10">10</option>
                                      <option value="25">25</option>
                                      <option value="50">50</option>
                                      <option value="100">100</option>
                                    </select>{" "}
                                    entries per page
                                  </label>
                                </div>
                              </div>
                            </div>

                            {data.length === 0 ? (
                              <table
                                id="tableLedger"
                                class="table table-striped table-bordered dt-responsive nowrap dataTable no-footer  collapsed"
                                role="grid"
                                aria-describedby="tableLedger_info"
                              >
                                <thead>
                                  <tr>
                                    <th
                                      class="sorting_asc"
                                      tabindex="0"
                                      aria-controls="tableLedger"
                                      aria-sort="ascending"
                                      aria-label="#: activate to sort column descending"
                                    >
                                      #
                                    </th>
                                    <th style={{ minWidth: "100px" }}>Event</th>
                                    <th
                                      class="sorting"
                                      tabindex="0"
                                      aria-controls="tableLedger"
                                      rowspan="1"
                                      colspan="1"
                                      aria-label="Runner: activate to sort column ascending"
                                    >
                                      Runner
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr class="odd">
                                    <td
                                      valign="top"
                                      colspan="6"
                                      class="dataTables_empty"
                                    >
                                      No data available in table
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            ) : (
                              <div
                                className="table-responsive p-1"
                                key={uniqueGridKey}
                              >
                                <table
                                  ref={gridTableRef}
                                  id="betHistoryTable"
                                  className="table table-striped table-bordered dataTable no-footer dtr-inline display mt-2"
                                  style={{ width: "100%" }}
                                >
                                  <thead>
                                    <tr>
                                      {cols.map((c) => (
                                        <th key={c.data || c.title}>
                                          {c.title}
                                        </th>
                                      ))}
                                    </tr>
                                  </thead>
                                  <tbody />
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>{`
  /* Report filter — match Account Statement */
  #BetHistoryFilterForm .bet-history-filter-row {
    align-items: center;
  }
  #BetHistoryFilterForm .bet-history-filter-select .form-control {
    width: 100%;
    border: 1px solid #ced4da;
    background-color: #ffffff;
    color: #212529;
    height: calc(1.5em + 0.75rem + 2px);
  }
  #BetHistoryFilterForm .datee,
  #BetHistoryFilterForm .datetimepicker-input {
    background-color: #ffffff !important;
    color: #212529;
    font-size: 1rem;
  }
  #BetHistoryFilterForm .input-group.date {
    width: 100%;
    flex-wrap: nowrap;
  }
  #BetHistoryFilterForm .input-group .form-control {
    border: 1px solid #ced4da;
    border-right: 0;
    border-radius: 0.25rem 0 0 0.25rem;
    height: calc(1.5em + 0.75rem + 2px);
  }
  #BetHistoryFilterForm .input-group-append .input-group-text {
    background-color: #e9ecef;
    border: 1px solid #ced4da;
    border-left: 0;
    border-radius: 0 0.25rem 0.25rem 0;
    cursor: pointer;
    color: #495057;
  }
  #BetHistoryFilterForm .input-group-append .input-group-text:hover {
    background-color: #dde2e6;
  }
  #BetHistoryFilterForm .bootstrap-datetimepicker-widget {
    z-index: 1050 !important;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }
  #BetHistoryFilterForm .bootstrap-datetimepicker-widget table td.active,
  #BetHistoryFilterForm .bootstrap-datetimepicker-widget table td.active:hover,
  #BetHistoryFilterForm .bootstrap-datetimepicker-widget table td span.active {
    background-color: #00b181 !important;
    color: #fff !important;
  }
  #BetHistoryFilterForm .bootstrap-datetimepicker-widget table td.today:before {
    border-bottom-color: #00b181;
  }
  #BetHistoryFilterForm .bootstrap-datetimepicker-widget table thead tr:first-child th:hover {
    background: #e9ecef;
  }
  @media screen and (min-width: 768px) {
    #BetHistoryFilterForm {
      justify-content: flex-start;
    }
    #BetHistoryFilterForm .bet-history-filter-row {
      justify-content: flex-start;
      text-align: left;
      margin-left: 0;
      margin-right: 0;
    }
    #BetHistoryFilterForm .bet-history-filter-select {
      flex: 0 0 auto;
      max-width: none;
      padding-left: 0;
      padding-right: 0.5rem;
    }
    #BetHistoryFilterForm .bet-history-filter-dash {
      margin: 0 0.5rem;
      align-self: center;
      flex: 0 0 auto;
    }
    #BetHistoryFilterForm .bet-history-filter-date {
      flex: 0 0 250px;
      max-width: 250px;
      width: 250px;
      padding-left: 0;
      padding-right: 0.5rem;
    }
    #BetHistoryFilterForm .bet-history-filter-date .input-group.date {
      width: 250px;
      max-width: 250px;
    }
    #BetHistoryFilterForm .editsbmtbtn {
      margin-left: 0;
      flex: 0 0 auto;
      text-align: left;
    }
  }
  @media screen and (max-width: 640px) {
    #BetHistoryFilterForm .bet-history-filter-row {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
      justify-content: flex-start;
    }
    #BetHistoryFilterForm .bet-history-filter-select {
      flex: 0 0 50%;
      max-width: 50%;
      width: 50%;
      padding-left: 0;
      padding-right: 4px;
    }
    #BetHistoryFilterForm .bet-history-filter-select + .bet-history-filter-select {
      padding-left: 4px;
      padding-right: 0;
    }
    #BetHistoryFilterForm .bet-history-filter-select .form-control {
      width: 100%;
      max-width: 100%;
    }
    #BetHistoryFilterForm .bet-history-filter-date {
      flex: 0 0 100%;
      max-width: 100%;
      width: 100%;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    #BetHistoryFilterForm .bet-history-filter-date-from {
      margin-top: 20px;
    }
    #BetHistoryFilterForm .bet-history-filter-date .form-group {
      width: 100%;
      margin-bottom: 0;
    }
    #BetHistoryFilterForm .bet-history-filter-dash {
      display: block;
      flex: 0 0 100%;
      width: 100%;
      text-align: center;
      margin: 0.25rem 0;
    }
    #BetHistoryFilterForm .bet-history-filter-date .input-group.date {
      width: 100% !important;
      max-width: 100% !important;
    }
    #BetHistoryFilterForm .input-group .form-control {
      flex: 1 1 auto;
      min-width: 0;
      width: 1%;
      text-align: left;
    }
    #BetHistoryFilterForm .editsbmtbtn {
      flex: 0 0 100%;
      width: 100% !important;
      max-width: 100%;
      display: flex !important;
      justify-content: flex-end !important;
      align-items: center !important;
      margin-top: 0.5rem;
      padding-right: 0;
    }
    #BetHistoryFilterForm .editsbmtbtn .btn {
      margin-right: 0;
    }
  }

  #betHistoryTable_wrapper .table-responsive {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  #betHistoryTable_wrapper .table.table-striped td,
  #betHistoryTable_wrapper .table.table-striped th {
    padding: 6px 8px !important;
    font-size: 17px;
    white-space: nowrap;
    vertical-align: middle;
  }
  #betHistoryTable_wrapper tr.shown + tr > td {
    background-color: #ffffff !important;
  }
  .seq-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100%;
    margin: 0 auto;
  }
  .seq-cell .seq-number { flex: 0 0 auto; }
  .toggle-row {
    border: none;
    outline: none;
    cursor: pointer;
    width: 15px;
    height: 15px;
    margin-left: 2px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-weight: 700;
    font-size: 16px;
    color: #fff;
    line-height: 1;
    box-shadow: none;
    -webkit-tap-highlight-color: transparent;
  }
  .toggle-row:focus,
  .toggle-row:focus-visible {
    outline: none !important;
    box-shadow: none !important;
  }
  .toggle-closed { background-color: #28a745; }
  .toggle-open { background-color: #dc3545; }
  .toggle-row:active { transform: scale(0.94); }
  #betHistoryTable_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > td:first-child:before,
  #betHistoryTable_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > th:first-child:before,
  #betHistoryTable_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr.parent > td:first-child:before,
  #betHistoryTable_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr.parent > th:first-child:before {
    display: none !important;
    content: none !important;
  }
  #betHistoryTable_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > td:first-child,
  #betHistoryTable_wrapper table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > th:first-child {
    padding-left: 8px !important;
    padding-right: 8px !important;
    cursor: default;
  }
  .dt-info { float: none !important; text-align: center !important; }
  .dt-paging-button { margin-left: 0 !important; padding: 0 !important; }
  .dt-paging { text-align: center !important; }
  .pagination { display: block !important; }
  #betHistoryTable_wrapper .table-responsive > table.dataTable {
    table-layout: fixed;
    width: 100% !important;
  }
  #betHistoryTable_wrapper table.dataTable thead th:nth-child(2),
  #betHistoryTable_wrapper table.dataTable tbody td:nth-child(2) {
    min-width: 0;
    box-sizing: border-box;
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: break-word;
    vertical-align: middle !important;
  }
  #betHistoryTable_wrapper table.dataTable thead th:nth-child(3),
  #betHistoryTable_wrapper table.dataTable tbody td:nth-child(3) {
    min-width: 0;
    box-sizing: border-box;
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: break-word;
    vertical-align: middle !important;
  }
  #betHistoryTable_wrapper table.dataTable thead th:nth-child(4),
  #betHistoryTable_wrapper table.dataTable tbody td:nth-child(4),
  #betHistoryTable_wrapper table.dataTable thead th:nth-child(5),
  #betHistoryTable_wrapper table.dataTable tbody td:nth-child(5),
  #betHistoryTable_wrapper table.dataTable thead th:nth-child(6),
  #betHistoryTable_wrapper table.dataTable tbody td:nth-child(6),
  #betHistoryTable_wrapper table.dataTable thead th:nth-child(7),
  #betHistoryTable_wrapper table.dataTable tbody td:nth-child(7),
  #betHistoryTable_wrapper table.dataTable thead th:nth-child(8),
  #betHistoryTable_wrapper table.dataTable tbody td:nth-child(8) {
    text-align: right !important;
    white-space: nowrap;
  }
  #betHistoryTable_wrapper table.ledger-child-table {
    width: 100% !important;
    table-layout: fixed;
    margin: 0 !important;
  }
  #betHistoryTable_wrapper td.ledger-detail-cell {
    border-top: 0 !important;
    border-left: 0 !important;
    border-right: 0 !important;
    border-bottom: 1px solid #eee !important;
    padding: 8px 10px !important;
    vertical-align: middle !important;
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: break-word;
    text-align: left;
    background-color: #ffffff !important;
  }
  #betHistoryTable_wrapper .ledger-detail-line {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    justify-content: flex-start;
    gap: 0 0.35rem;
    line-height: 1.4;
  }
  #betHistoryTable_wrapper .ledger-detail-label {
    font-weight: 700 !important;
    color: #000 !important;
    font-size: 0.95rem !important;
    flex: 0 0 auto;
    margin-bottom: 0 !important;
  }
  #betHistoryTable_wrapper .ledger-detail-value {
    font-size: 0.95rem;
    color: #212529;
    flex: 1 1 auto;
    min-width: 0;
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: break-word;
  }
  .dt-search {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    margin-top: 10px !important;
    float: none !important;
    justify-content: center;
  }
  .dt-search .form-control {
    border: 1px solid #ced4da;
    margin-bottom: 5px;
    background-color: #ffffff;
    color: #212529;
  }
  .actionBtn {
    position: absolute;
    width: 100%;
    margin-top: 10px;
    z-index: 10;
  }
  .dataTable {
    margin-top: 15px;
  }
  @media screen and (max-width: 640px) {
    .table-wrap {
      padding-left: 10px !important;
      padding-right: 10px !important;
    }
    #betHistoryTable_wrapper .table-responsive > table.dataTable {
      width: 90% !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }
    #betHistoryTable_wrapper table.dataTable thead th:nth-child(1),
    #betHistoryTable_wrapper table.dataTable tbody td:nth-child(1) {
      width: 12% !important;
    }
    #betHistoryTable_wrapper table.dataTable thead th:nth-child(3),
    #betHistoryTable_wrapper table.dataTable tbody td:nth-child(3) {
      width: 88% !important;
      min-width: 0 !important;
    }
    #betHistoryTable_wrapper td.ledger-detail-cell {
      padding-left: 12% !important;
    }
    .actionBtn {
      width: 100%;
      margin-top: 20px;
      position: relative;
    }
    .dt-search {
      display: flex !important;
      justify-content: center !important;
      width: 100% !important;
      margin: 8px 0 !important;
      padding: 0 12px;
      box-sizing: border-box;
    }
    .dt-search input[type="search"],
    .dataTables_filter input[type="search"] {
      width: 160px !important;
      max-width: 80% !important;
      display: inline-block !important;
      margin: 0 !important;
      border: 1px solid #ced4da !important;
      background-color: #ffffff !important;
      color: #212529 !important;
    }
    .top.d-flex {
      flex-direction: column;
      align-items: center;
      gap: 8px;
    }
    .table-responsive {
      margin-top: 0 !important;
    }
    .dataTable {
      margin-top: 10px !important;
    }
  }
`}</style>
    </>
  );
};

export default BetHistoryContent;
